import { ROASRow } from '../dtc-commerce-mmm-types';

// How a tag reads: good news, bad news, a caution, or neutral context.
export const TagTone = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
  CAUTION: 'caution',
  NEUTRAL: 'neutral',
  BRAND: 'brand'
} as const;
export type TagToneType = (typeof TagTone)[keyof typeof TagTone];

// Display details for a feature card.
export interface InsightFeatureMeta {
  row: ROASRow;
  displayName: string;
}

// ---- Windows ----
export const WEEKS_PER_YEAR = 52;

// ---- Thresholds (first picks; tune against real cards) ----
// The next dollar earns at least this share of the average dollar: the curve hasn't flattened.
export const ROOM_TO_SCALE_MIN_RATIO = 0.8;
// The next dollar earns at most this share of the average dollar: returns are diminishing.
export const DIMINISHING_MAX_RATIO = 0.5;
// Return per dollar vs the same weeks last year.
export const RETURN_TREND_MIN_CHANGE = 0.25;
// Spend vs the same weeks last year.
export const SPEND_SHIFT_MIN_CHANGE = 0.5;
// Share of results vs share of spend over the last 12 months.
export const ABOVE_WEIGHT_MIN_RATIO = 2;
export const BELOW_WEIGHT_MAX_RATIO = 0.5;
// A week counts as a spike at this multiple of the median week over the last year.
export const SPIKE_MIN_RATIO = 1.5;
// A month counts as a peak at this multiple of a typical week.
export const SEASONAL_PEAK_MIN_INDEX = 1.3;

// Revenue KPIs: $1 back per $1 spent.
export const BREAK_EVEN_RETURN = 1;
